import { render } from "./AuSelect.vue?vue&type=template&id=1aaff6a2"
import script from "./AuSelect.vue?vue&type=script&lang=js"
export * from "./AuSelect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AuSelect.vue?vue&type=style&index=1&id=1aaff6a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__